import { AlphaABoxIcon } from './AlphaABoxIcon';

/**
 * author: GreenTurtwig
 * id 1AC5B76A-B93F-4F9B-851D-C3DAF9743046
 * name alpha-a-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-a-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterABoxIcon = AlphaABoxIcon;
export default LetterABoxIcon